export default {
    parts: [
        // modal parts
        'formBox',
        'errorText',
        'successBox',
        'successIcon',
        'successText',
        'successTextFlex',
        'retryFlex',
        'retryIcon',
        'retryButton',
        'similarBox',
        'similarTitle',
        'similarSubtitle',
        'similarGrid',
        'similarItem',
        // fields parts
        'emailFieldContainer',
        'submitButtonContainer',
        'submitButton',
        'submitSpinner',
        'submitIcon',
        'checkboxInputProps',
        'checkboxLabelProps'
    ],
    baseStyle: {
        formBox: {},
        errorText: {
            color: 'webTypo.textError',
            mt: 2
        },
        successBox: {},
        successTextFlex: {
            mt: 4,
            alignItems: 'flex-start'
        },
        successIcon: {
            width: '16px',
            height: '16px',
            mr: '4.5px',
            flexShrink: 0
        },
        successText: {
            textStyle: 'bodyXsRegular'
        },
        retryFlex: {
            mt: 4,
            alignItems: 'center'
        },
        retryIcon: {
            width: '20px',
            height: '20px',
            mr: '4.5px',
            flexShrink: 0
        },
        retryButton: {
            display: 'flex',
            alignItems: 'center',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            p: 0
        },
        similarBox: {
            mt: '40px'
        },
        similarGrid: {
            mt: 4,
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gridColumnGap: 2,
            gridRowGap: 3,
            width: '100%'
        },
        similarItem: {
            width: '100%',
            minWidth: '0'
        },
        // fields
        submitButtonContainer: {
            h: '100%',
            w: '48px',
            backgroundColor: 'webTheme.backgroundReverse'
        },
        submitButton: {
            minW: 'auto',
            h: '100%'
        },
        submitSpinner: {
            mt: '4px',
            color: 'white'
        },
        submitIcon: {
            w: '16px',
            h: '16px',
            mb: '3px'
        },
        checkboxInputProps: {
            alignItems: 'flex-start',
            mt: 4
        },
        checkboxLabelProps: {
            display: 'block',
            textStyle: 'bodyXsRegular',
            mt: 0
        }
    }
}
